import moment from 'moment';

/**
 * Prepares the request body for MetaDatabyID API endpoints
 * Ensures DocID and Year are present and properly formatted according to backend validation rules
 * @param {Object} data - The data object to be sent in the request
 * @param {string} docId - The DocID value (used if not present in data)
 * @returns {Object} - The normalized request body
 */
export const prepareMetaDatabyIdRequestBody = (data, docId) => {
  console.log('[prepareMetaDatabyIdRequestBody] === START DATA PREPARATION ===');
  console.log('[prepareMetaDatabyIdRequestBody] Input data:', JSON.stringify(data));
  console.log('[prepareMetaDatabyIdRequestBody] Input docId parameter:', docId);
  
  const body = { ...data };

  // Ensure DocID is a string (digits only) in the request body
  if (!body.DocID && docId) {
    body.DocID = String(docId).trim();
    console.log('[prepareMetaDatabyIdRequestBody] DocID set from parameter, value:', body.DocID);
  } else if (body.DocID) {
    const originalDocID = body.DocID;
    body.DocID = String(body.DocID).trim();
    console.log('[prepareMetaDatabyIdRequestBody] DocID from data:', originalDocID, '-> trimmed:', body.DocID);
  }

  // Validate DocID format (must not be empty)
  if (!body.DocID) {
    console.error('[prepareMetaDatabyIdRequestBody] VALIDATION ERROR: DocID is missing or empty');
  } else {
    console.log('[prepareMetaDatabyIdRequestBody] DocID validation passed:', body.DocID);
  }

  // Ensure Year is a 4-digit string
  let yearValue = body.Year;
  console.log('[prepareMetaDatabyIdRequestBody] Initial Year value:', yearValue);
  console.log('[prepareMetaDatabyIdRequestBody] Initial Release value:', body.Release);
  
  // First, try to extract year from Release date if Year is not valid
  if (!yearValue || String(yearValue).toString().trim().length !== 4 || !/^\d{4}$/.test(String(yearValue).toString())) {
    console.log('[prepareMetaDatabyIdRequestBody] Year is invalid or missing, attempting extraction from Release...');
    if (body.Release && body.Release.toString().trim().length > 0) {
      const releaseStr = body.Release.toString().trim();
      console.log('[prepareMetaDatabyIdRequestBody] Release string:', releaseStr);
      // Extract first 4 characters (YYYY from YYYY-MM-DD format)
      const yearMatch = releaseStr.match(/^(\d{4})/);
      if (yearMatch && yearMatch[1]) {
        yearValue = yearMatch[1];
        console.log('[prepareMetaDatabyIdRequestBody] Successfully extracted Year from Release:', yearValue);
      } else {
        // If Release exists but doesn't match expected format, use current year as fallback
        console.warn('[prepareMetaDatabyIdRequestBody] Release date in unexpected format:', releaseStr, '- using current year');
        yearValue = moment().format('YYYY');
      }
    } else {
      // Fallback to current year if Release is not available
      console.warn('[prepareMetaDatabyIdRequestBody] Release date not available - using current year');
      yearValue = moment().format('YYYY');
    }
  }
  
  // Ensure Year is always a string
  body.Year = String(yearValue).trim();
  console.log('[prepareMetaDatabyIdRequestBody] Final Year value:', body.Year);

  // Final validation
  if (!/^\d{4}$/.test(body.Year)) {
    console.error('[prepareMetaDatabyIdRequestBody] VALIDATION ERROR: Year validation failed. Year value:', body.Year, 'Release:', body.Release);
  } else {
    console.log('[prepareMetaDatabyIdRequestBody] Year validation passed');
  }

  console.log('[prepareMetaDatabyIdRequestBody] === FINAL REQUEST BODY ===');
  console.log('[prepareMetaDatabyIdRequestBody]', JSON.stringify(body));
  return body;
};
